module.exports = __webpack_public_path__ + "img/smart-contract.dcc8a7de.png";